var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransparentreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 2.5v2h2v-2zm2 2v2.66667h2.66667v-2.66667zm2.66667 0h2.66666v-2h-2.66666zm2.66666 0v2.66667h2.66667v-2.66667zm2.66667 0h2v-2h-2zm0 2.66667v2.66666h2v-2.66666zm0 2.66666h-2.66667v2.66667h2.66667zm0 2.66667v2h2v-2zm-2.66667 0h-2.66666v2h2.66666zm-2.66666 0v-2.66667h-2.66667v2.66667zm-2.66667 0h-2v2h2zm0-2.66667v-2.66666h-2v2.66666zm2.66667 0h2.66666v-2.66666h-2.66666z",
    fill: "currentColor"
  })));
}
export default SvgTransparentreact;